import styled from '@emotion/styled';
import { useState } from 'react';
import { Fade, Grid, Typography } from '@mui/material';
import HostBlob from './host-blob';
import { textStrings } from '../constant';
import { config } from '@/config/environment';

const SecondDiv = styled(Grid)`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  margin-bottom: 120px;
  margin-top: 60px;
`;
const TextDiv = styled.div`
  width: 326px;
  text-align: start;
  margin: 0 auto 0 auto;
`;
const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: opacity 1s linear;
`;
const Subtitle = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 137.8%;
  color: #231727;
  text-align: start;
  margin-bottom: 32px;
`;
const HostBlobs = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 100px;
  padding-right: 60px;
`;
const BlobsGroup1 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const BlobsGroup2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const BlobLeft = styled.div`
  margin: 20px 20px 0 0px;
  :hover {
    cursor: pointer;
  }
`;
const BlobRight = styled.div`
  margin: 20px;
  :hover {
    cursor: pointer;
  }
`;
const BlobMiddle = styled.div`
  margin: 80px 20px 0 20px;
  :hover {
    cursor: pointer;
  }
`;
const HostTitle = styled(Typography)`
  font-family: var(--font-cooper-light), sans-serif;
  font-size: 50px;
  line-height: 109.3%;
  text-align: start;
  z-index: 1;
  color: #231727;
  margin-bottom: 50px;
`;
const GalaxyName = styled(Typography)`
  font-family: var(--font-cooper-light), sans-serif;
  line-height: 109.3%;
  text-align: start;
  z-index: 1;
  color: #231727;
  font-size: 40px;
  margin-top: 0;
  margin-bottom: 20px;
`;
const Text = styled(Typography)`
  font-family: var(--font-work-sans);
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 160%;
  color: #231727;
`;
const DeskTopView = () => {
  const [textSwitch, setTextSwitch] = useState<boolean>(true);
  const [state, setState] = useState({
    activeGalaxy: '',
    displayDefault: true,
    text: 'Click on the galaxies to explore what it means to become a host.',
    subtitle: '',
    title: '',
  });

  const handleGalaxySelect = (selectedGalaxy: string) => {
    const value = textStrings[selectedGalaxy as keyof typeof textStrings];
    setTextSwitch(!textSwitch);
    setTimeout(() => {
      setState({
        ...state,
        activeGalaxy: selectedGalaxy,
        displayDefault: false,
        text: value.text || '',
        subtitle: value.subtitle || '',
        title: value.title || '',
      });
      setTextSwitch(!!textSwitch);
    }, 500);
  };
  return (
    <SecondDiv container>
      <TextDiv>
        <HostTitle style={{ color: state.displayDefault ? '#231727' : '#BF9BB9' }}>
          {config.platformMode === 'archive' ? 'Community members became Hosts to...' : 'Why Host?'}
        </HostTitle>
        <Fade in={textSwitch} timeout={500}>
          <TextSection>
            <Subtitle>{state.subtitle}</Subtitle>
            <GalaxyName>{state.title}</GalaxyName>
            <Text style={{ color: state.displayDefault ? '#828282' : '#231727' }}>
              {state.text}
            </Text>
          </TextSection>
        </Fade>
      </TextDiv>
      <HostBlobs>
        <BlobsGroup1>
          <BlobLeft onClick={() => handleGalaxySelect('shareWhatYouLove')}>
            <HostBlob
              label="Share what you love"
              vector="/discover/hosting/group1.png"
              labelColor="#4D66B1"
              opacity={
                state.activeGalaxy === 'shareWhatYouLove' || state.activeGalaxy === '' ? 1 : 0.3
              }
            />
          </BlobLeft>
          <BlobRight
            onClick={() => {
              handleGalaxySelect('doSomethingGood');
            }}
          >
            <HostBlob
              label="Gain perspective"
              vector="/discover/hosting/group2.png"
              labelColor="#816352"
              opacity={
                state.activeGalaxy === 'doSomethingGood' || state.activeGalaxy === '' ? 1 : 0.3
              }
            />
          </BlobRight>
        </BlobsGroup1>
        <BlobsGroup2>
          <BlobLeft
            onClick={() => {
              handleGalaxySelect('challengeYourPerspective');
            }}
          >
            <HostBlob
              label="Learn and grow"
              vector="/discover/hosting/group3.png"
              labelColor="#F0926E"
              opacity={
                state.activeGalaxy === 'challengeYourPerspective' || state.activeGalaxy === ''
                  ? 1
                  : 0.3
              }
            />
          </BlobLeft>
          <BlobMiddle
            onClick={() => {
              handleGalaxySelect('shareWhatYouLove1');
            }}
          >
            <HostBlob
              label="Set your own schedule"
              vector="/discover/hosting/group4.png"
              labelColor="#5995A8"
              opacity={
                state.activeGalaxy === 'shareWhatYouLove1' || state.activeGalaxy === '' ? 1 : 0.3
              }
            />
          </BlobMiddle>
          <BlobRight
            onClick={() => {
              handleGalaxySelect('bePartOfAnEquitableFuture');
            }}
          >
            <HostBlob
              label="Be part of the change you want to see"
              vector="/discover/hosting/group5.png"
              labelColor="#4B9E6F"
              opacity={
                state.activeGalaxy === 'bePartOfAnEquitableFuture' || state.activeGalaxy === ''
                  ? 1
                  : 0.3
              }
            />
          </BlobRight>
        </BlobsGroup2>
      </HostBlobs>
    </SecondDiv>
  );
};

export default DeskTopView;
